module.exports = __webpack_public_path__ + "img/njuskalo.f8c2e03d.svg";